import { Fragment } from 'react';

import useAthleteUserContactsDetail from './UseAthleteUserContactsDetail';

import Views from '../AthleteUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeAthleteEntry/ViewTemplate';

import SearchMemberWithLscPopup from '@usas/ui-web/components/searches/searchMember/SearchMemberWithLscPopup';
import Input from '@usas/ui-web/components/inputs/Input';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

const AthleteUserContactsDetail = () => {
  const { orgUnitAthleteContactState, orgUnitAthleteEntryInfoState, formState, errorState, setFormData, handleSubmit, onFormValueChanged,
    onNextButtonClicked, onBackButtonClicked } = useAthleteUserContactsDetail();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_CONTACTS_DETAIL}
        onNextButtonClicked={onNextButtonClicked}
        onBackButtonClicked={onBackButtonClicked}
        errorMessage={errorState.error}>
        <form onSubmit={handleSubmit} noValidate>
          <div className='row'>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <SearchMemberWithLscPopup
                label={'Member Id*'}
                memberIdName={'memberId'}
                formState={formState}
                errorState={errorState}
                setFormData={setFormData}
                onFormValueChanged={onFormValueChanged} />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Input
                label="Email*"
                name="emailAddress"
                value={formState.emailAddress}
                error={errorState.emailAddress}
                message={errorState.emailAddress}
                onChange={(value) => { onFormValueChanged('emailAddress', value); }}
              />
            </div>
          </div>
        </form>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={orgUnitAthleteContactState.isSaving} />
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={orgUnitAthleteEntryInfoState.isObjLoading} />
      </ViewTemplate>
    </Fragment>
  );
};

export default AthleteUserContactsDetail;